import React from 'react';
import styles from './styles.scss';

type Props = {
  href: string | undefined;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  isConnected: boolean;
  signOnText: string;
};

const Logo = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3496_198)">
      <path
        d="M23.5 12.2383C23.5 5.88706 18.3513 0.738337 12 0.738337C5.64872 0.738337 0.5 5.88706 0.5 12.2383C0.5 17.9783 4.70538 22.7359 10.2031 23.5986V15.5626H7.2832V12.2383H10.2031V9.70474C10.2031 6.82256 11.92 5.23052 14.5468 5.23052C15.805 5.23052 17.1211 5.45513 17.1211 5.45513V8.28521H15.671C14.2424 8.28521 13.7969 9.17168 13.7969 10.0811V12.2383H16.9863L16.4765 15.5626H13.7969V23.5986C19.2946 22.7359 23.5 17.9783 23.5 12.2383Z"
        fill="#216CEB"
      />
    </g>
    <defs>
      <clipPath id="clip0_3496_198">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.168457)"
        />
      </clipPath>
    </defs>
  </svg>
);

const Facebook: React.FC<Props> = ({
  href,
  isConnected,
  onClick,
  signOnText,
}) => {
  return (
    <a
      href={!isConnected ? href : undefined}
      className={styles.container}
      style={{
        cursor: isConnected ? 'default' : 'pointer',
        borderColor: '#216CEB',
      }}
      onClick={onClick}
    >
      <div className={styles.innerContainer}>
        {!isConnected && <Logo />}
        <p style={{ marginLeft: 8, color: '#216CEB' }}>
          {!isConnected ? signOnText : 'Connected'}
        </p>
      </div>
    </a>
  );
};

export default Facebook;
